module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.pl/pl_pl/grohe/ochrona-prywatnosci.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.pl/pl_pl/grohe/zastrzezenia-prawne.html",
	"footer.copyright": "&copy; 2018 Grohe Polska Sp. z o.o.",
	"homepage.headline": "Konfigurator GROHE SmartControl",
	"homepage.introtext": "Odpowiedz na kilka poniższych pytań, żeby znaleźć najbardziej odpowiedni dla Ciebie wariant systemu prysznicowego  GROHE SmartControl.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "Zobacz wyniki",
	"question1.question": "Do którego miejsca w Twojej łazience potrzebna jest konfiguracja prysznica?",
	"question1.option1.text": "Do kabiny prysznicowej",
	"question1.option2.text": "Do wanny",
	"question2.question": "Który rodzaj instalacji wybierasz? Instalację natynkową, podtynkową czy kombinację tych dwóch opcji?",
	"question2.option1.text": "Instalacja natynkowa: łatwe i wygodne rozwiązanie z montażem na ścianie",
	"question2.option2.text": "Kombinacja: instalacja wewnątrz ściany oraz bateria termostatyczna z półką na ścianie",
	"question2.option3.text": "Instalacja podtynkowa: minimalistyczny wygląd z technologią ukrytą w ścianie",
	"question3.question": "Jaki sposób prysznica prysznica wybierasz?",
	"question3.option1.text": "Bateria SmartControl",
	"question3.option2.text": "Tradycyjna bateria termostatyczna",
	"question3.option3.text": "Bateria jednouchwytowa",
	"question3.option4.text": "System przełączników (do montażu przy istniejącej baterii)",
	"question4.question": "Co chcesz obsługiwać za pomocą swojego prysznica?",
	"question4.option1.text": "Tylko prysznic ręczny",
	"question4.option2.text": "Dużą deszczownicę (150-250mm) oraz prysznic ręczny",
	"question4.option3.text": "Dużą deszczownicę  (250-400mm) oraz prysznic ręczny",
	"question4.option4.text": "Duża deszczownica (150-250mm), prysznic ręczny i wylewka wannowa",
	"question4.option5.text": "Duża deszczownica (250-400mm), prysznic ręczny i wylewka wannowa",
	"question5.question": "Jaki kształt wolisz?",
	"question5.option1.text": "Kwadrat",
	"question5.option2.text": "Koło",
	"question6.question": "Co chcesz obsługiwać za pomocą systemu SmartControl?",
	"question6.option1.text": "Deszczownicę z dwoma rodzajami strumieni i prysznic ręczny",
	"question6.option2.text": "Deszczownicę i prysznic ręczny",
	"question6.option3.text": "Tylko prysznic ręczny",
	"question6.option4.text": "Deszczownicę z dwoma rodzajami strumieni i prysznic ręczny",
	"question6.option5.text": "Deszczownicę, dwa prysznice boczne i prysznic ręczny",
	"question6.option6.text": "Deszczownicę, prysznic ręczny i wylewkę wannową",
	"question6.option7.text": "Prysznic ręczny i wylewkę wannową",
	"question6.option8.text": "Tylko wylewkę wannową",
	"question7.question": "Wybierz kolor",
	"question7.option1.text": "Chrome",
	"question7.option2.text": "MoonWhite",
	"question7.option3.text": "MoonWhite",
	"question8.question": "Czy chcesz baterię termostatyczną z uchwytem na prysznic ręczny?",
	"question8.option1.text": "Tak, chcę baterię z uchwytem na prysznic ręczny",
	"question8.option2.text": "Nie, uchwyt na prysznic ręczny kupię osobno",
	"question9.question": "W jakim sposób prysznic ręczny powinien być umiejscowiony?",
	"question9.option1.text": "Na drążku prysznicowym z uchwytem prysznicowym o regulowanej wysokości",
	"question9.option2.text": "Na uchwycie punktowym",
	"question10.question": "Chcesz zamontować deszczownicę na ścianie czy na suficie?",
	"question10.option1.text": "Deszczownica montowana na ścianie",
	"question10.option2.text": "Deszczownica montowana na suficie",
	"results.title": "{productGroupsCount, plural, \none {Twój wynik} \nother {Twoje wyniki}\n}",
	"results.proposal.title": "REKOMENDACJA {number}",
	"results.proposal.title.single": "REKOMENDACJA ",
	"results.bundle.title": "W celu zapewnienia prawidłowej instalacji, potrzebne będą również:",
	"results.newConfiguration.title": "Rozpocznij nową konfigurację",
	"results.newConfiguration.buttonText": "Rozpocznij nową konfigurację",
	"results.product.number": "Numer produktu: {number}",
	"results.product.button.productInformation": "Informacje o produkcie  ",
	"results.product.button.dealerLocator": "Znajdź salon sprzedaży  ",
	"results.product.button.buyNow": "Kup online  ",
	"results.product.button.downloadPDF": "Pobierz PDF",
	"results.product.information": "Informacje o produkcie  ",
	"results.product.dealer": "Znajdź salon sprzedaży  ",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/shower.pl_pl.json
// module id = 763
// module chunks = 0